import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import rememberGuestFavourite from "@/frontend/utils/rememberGuestFavourite"

export default class extends Controller {
  static targets = ["heart"]

  connect() {
    if (!window.config?.userSignedIn) return

    this.hydrate()
  }

  async hydrate() {
    const listingIds = this.heartTargets.map((heart) => heart.dataset.listingId)
    if (listingIds.length === 0) return

    const params = new URLSearchParams(listingIds.map((id) => ["listing_ids[]", id]))
    const response = await fetch(`/listings/favourites/ids?${params}`, {
      headers: { Accept: "application/json" },
    })
    if (!response.ok) return

    const favouritedIds = new Set(await response.json())
    this.heartTargets.forEach((heart) => {
      if (favouritedIds.has(Number(heart.dataset.listingId))) {
        heart.dataset.favourited = "true"
        heart.setAttribute("aria-label", "Remove from favourites")
        heart.dataset.gtmTrigger = "remove_from_favorites"
      }
    })
    this.element.dataset.favouritesHydrated = "true"
  }

  async toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const heart = event.currentTarget
    if (!window.config?.userSignedIn) {
      rememberGuestFavourite(Number(heart.dataset.listingId))
      document.dispatchEvent(
        new CustomEvent("show-session-modal", { detail: { title: "Login to favourite artworks" } }),
      )
      return
    }

    if (heart.disabled) return

    heart.disabled = true
    try {
      const favourited = heart.dataset.favourited === "true"
      const response = await fetch(`/artworks/${heart.dataset.listingId}/favourites`, {
        method: favourited ? "DELETE" : "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          Accept: "text/vnd.turbo-stream.html",
        },
      })
      if (response.ok) Turbo.renderStreamMessage(await response.text())
    } finally {
      heart.disabled = false
    }
  }
}
